<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a class="logo logo-dark">
          <span class="logo-lg">
            <img src="assets/images/Automatr_logo.svg" class="logo_size" alt="Logo" />
          </span>
          <!-- Icon-only logo shown on mobile/tablet (≤992px) where the full logo is hidden -->
          <span class="logo-sm">
            <img src="assets/images/Automatr_icon.svg" alt="Logo" class="logo-sm-img" />
          </span>
        </a>
      </div>

      <!-- Mobile menu toggle (visible only on mobile) -->
      <button type="button" class="btn btn-sm px-3 font-size-16 header-item d-lg-none" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- Customer branding logo (optional; served by the Orchestrator from AccountInfo) -->
      <div class="custom-account-logo d-none d-lg-flex" *ngIf="accountLogo">
        <img [src]="accountLogo" alt="Account logo" />
      </div>

      <!-- Current tenant label removed from the header — the tenant is now shown
           under the selected workspace in the workspace dropdown. -->

      <!-- Queue / Item Priority / Custom Status tabs — desktop only; on
           mobile/tablet each queue page shows the same component under its
           title instead, so the topbar keeps its normal one-row layout. -->
      <div class="queue-tabs-wrap" *ngIf="queuesCheck">
        <app-queue-tabs></app-queue-tabs>
      </div>
    </div>

    <div class="d-flex">

      <!-- Go to Accounts Button (desktop/tablet only — moved into the user dropdown on mobile) -->
      <button type="button" class="btn btn-soft-primary btn-sm me-2 align-self-center desktop-only-item" style="padding: 5px 12px; font-size: 13px;" (click)="goToAccounts()"
      *ngIf="globals.isPlatformRole || globals.isAccountAdmin" title="Go to Accounts">
        <i class="bi bi-people me-1"></i>
        <span class="d-none d-lg-inline">Go to Accounts</span>
      </button>

      <!-- Tenant Selection Button (desktop/tablet only — moved into the user dropdown on mobile).
           Disabled when the user has access to only one tenant (nothing to switch to). -->
      <button type="button" class="btn btn-soft-primary btn-sm me-2 align-self-center desktop-only-item" style="padding: 5px 12px; font-size: 13px;" (click)="selectTenant()"
      [disabled]="!canSwitchTenant"
      [title]="canSwitchTenant ? 'Switch Tenant' : 'You have access to a single tenant'">
        <i class="bi bi-arrow-left-right me-1"></i>
        <span class="d-none d-lg-inline">Switch Tenant</span>
      </button>

      <div class="dropdown d-inline-block me-2 workspace-dropdown-wrap">
        <div class="selectBox">
          <p-dropdown [options]="workspaceOptions" #dropdown [(ngModel)]="globals.WorkSpaceID" [filter]="true"
            filterBy="workspace_name" optionLabel="workspace_name" optionValue="workspace_guid"
            panelStyleClass="workspace-dropdown-panel"
            (onChange)="workspaceChanged($event,dropdown)">
            <!-- Selected value only: workspace name with its tenant underneath.
                 The option list keeps the plain workspace name (default), since
                 every workspace shares the same tenant and repeating it clutters
                 the list. -->
            <ng-template let-ws pTemplate="selectedItem">
              <div class="ws-selected">
                <span class="ws-selected-name">{{ ws.workspace_name }}</span>
                <span class="ws-selected-tenant" *ngIf="(ws.tenant_name || currentTenantName)">
                  Tenant: {{ ws.tenant_name || currentTenantName }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <!-- Docs Button (desktop/tablet only — moved into the user dropdown on mobile) -->
      <button type="button" class="btn header-item noti-icon desktop-only-item align-self-center" title="Documentation" (click)="openDocs()">
        <i class="mdi mdi-book-open-variant"></i>
      </button>

      <div class="dropdown d-inline-block me-2 desktop-only-item align-self-center" ngbDropdown>
        <button type="button" class="btn header-item noti-icon position-relative"
          id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          ngbDropdownToggle>
          <i class="dripicons-bell"></i>
          @if(totalNotifications > 0){
          <span class="badge bg-danger rounded-pill">{{totalNotifications}}</span>
          }
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0"> Notifications </h6>
              </div>
              <div class="col-auto unreadCl">
                <label class="unreadlable">Show unread</label>
                <p-inputSwitch [(ngModel)]="showUnread" (onChange)="onSwitchChange()"></p-inputSwitch>
              </div>
            </div>
          </div>
          <ng-container *ngIf="listOfUnreadNotifications?.length; else noNewNotifications">
            <ngx-simplebar class="simpleBarCl">
              <ng-container *ngIf="isLoading; else content">
                <ng-container *ngFor="let _ of [1,2]">
                  <div class="skeCl">
                    <p-skeleton shape="circle" size="2rem" styleClass="mr-3 ml-2"></p-skeleton>
                    <div class="skeClP">
                      <p-skeleton width="100%" styleClass="mb-1"></p-skeleton>
                      <p-skeleton width="75%"></p-skeleton>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #content>
                <a class="notif-row cursor-pointer" *ngFor="let list of listOfUnreadNotifications"
                  (click)="onSingleView(list.notification_guid)">
                  <span class="notif-avatar" [class.unread]="!list.is_read">{{list.title | generateInitial}}</span>
                  <span class="notif-text">
                    <span class="notif-title">{{list.title}}</span>
                    <span class="notif-body">{{list.body | truncatePipe:30}}</span>
                  </span>
                </a>
              </ng-template>

            </ngx-simplebar>
          </ng-container>
          <ng-template #noNewNotifications>
            <p class="text-muted text-truncate text-center">No Notifications</p>
          </ng-template>
          <div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 text-center" (click)="onViewAllPageRoute()">
              <i class="mdi mdi-arrow-right-circle me-1"></i> <span>View All</span>
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block user-dropdown" ngbDropdown>
        <button type="button" class="btn header-item user-toggle"
          id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          ngbDropdownToggle>
          <span class="user-avatar">{{ avatarValue | uppercase }}</span>
          <span class="d-none d-xl-inline-block ms-2 user-name">{{
            profileName
            }}</span>
          <i class="bi bi-chevron-down d-inline-block ms-1 user-chevron"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end user-menu" ngbDropdownMenu>
          <!-- Mobile only: Go to Accounts / Switch Tenant / Docs / Notifications
               live here instead of in the header. -->
          <a class="user-menu-item user-menu-action mob-menu-item" (click)="goToAccounts()"
            *ngIf="globals.isPlatformRole || globals.isAccountAdmin">
            <i class="bi bi-people"></i>
            <span>Go to Accounts</span>
          </a>
          <!-- Disabled (greyed, non-clickable) when the user has access to only one tenant. -->
          <a class="user-menu-item user-menu-action mob-menu-item" (click)="canSwitchTenant && selectTenant()"
            [class.disabled]="!canSwitchTenant"
            [style.opacity]="canSwitchTenant ? null : '0.5'"
            [style.pointerEvents]="canSwitchTenant ? null : 'none'"
            [attr.aria-disabled]="!canSwitchTenant"
            [title]="canSwitchTenant ? 'Switch Tenant' : 'You have access to a single tenant'">
            <i class="bi bi-arrow-left-right"></i>
            <span>Switch Tenant</span>
          </a>
          <a class="user-menu-item user-menu-action mob-menu-item" (click)="openDocs()">
            <i class="mdi mdi-book-open-variant"></i>
            <span>Documentation</span>
          </a>
          <a class="user-menu-item user-menu-action mob-menu-item" (click)="onViewAllPageRoute()">
            <i class="dripicons-bell"></i>
            <span>Notifications</span>
            <span class="badge bg-danger rounded-pill ms-auto" *ngIf="totalNotifications > 0">{{totalNotifications}}</span>
          </a>
          <div class="user-menu-divider mob-menu-divider"></div>
          <a class="user-menu-item" (click)="onLogout()">
            <i class="bi bi-box-arrow-right"></i>
            <span>Log Out</span>
          </a>
        </div>
      </div>
    </div>
  </div>

</header>